import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobedreamweaverComponent } from './simple-icons-adobedreamweaver.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobedreamweaverComponent ],
    exports:      [ SimpleIconsAdobedreamweaverComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobedreamweaverModule {}
